import { ChangeDetectionStrategy, Component, OnInit, Signal, input } from '@angular/core';
import { WebsiteStateService } from '../../../state-management/services/website-state.service';
import { Result } from '../../../state-management/model/interfaces/state.model';
import { EditableTextComponent } from '../../base/text/editable-text/editable-text.component';
import { EditableButtonComponent } from '../../base/button/editable-button/editable-button.component';
import { EditableImageComponent } from '../../base/image/editable-image/editable-image.component';
import { FileType } from '../../../state-management/model/enums/state.enums';
import { MaxAspectRatioBreakpoints, ImageFormat, CoordinatesSystem, ScreenWidthBreakpoints } from '../../../state-management/model/enums/screen-size.enums';
import { ImageCoordinates } from '../../../state-management/model/interfaces/screen-size.model';
import { ScreensizeStateService } from '../../../state-management/services/screensize-state.service';

@Component({
    selector: 'app-c-hero',
    imports: [
        EditableTextComponent,
        EditableButtonComponent,
        EditableImageComponent
    ],
    templateUrl: './c-hero.component.html',
    styleUrl: './c-hero.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CHeroComponent implements OnInit {
  readonly componentId = input<string>('');

  public supportedFileTypes = [FileType.WEBP, FileType.JPEG];
  public imageReference: ImageCoordinates = {
    coordinatesSystem: CoordinatesSystem.MaxAspectRatio,
    formatMap: {
      [MaxAspectRatioBreakpoints.Landscape]: ImageFormat.SixteenToNine,
      [MaxAspectRatioBreakpoints.Portrait]: ImageFormat.NineToSixteen,
      [MaxAspectRatioBreakpoints.Square]: ImageFormat.OneToOne,
      [MaxAspectRatioBreakpoints.FourToThree]: ImageFormat.FourToThree,
      [MaxAspectRatioBreakpoints.ThreeToFour]: ImageFormat.ThreeToFour,
    }
  };
  public isSmallScreen$: Signal<boolean> = this.screensizeState.isScreenSizes(CoordinatesSystem.ScreenWidth, [ScreenWidthBreakpoints.Small, ScreenWidthBreakpoints.XSmall]);
  public titleId!: Signal<Result<string, string>>;
  public subtitleId!: Signal<Result<string, string>>;
  public highlightButtonId!: Signal<Result<string, string>>;
  public secondaryButtonId!: Signal<Result<string, string>>;
  public heroImageId!: Signal<Result<string, string>>;

  constructor(
    private stateService: WebsiteStateService,
    private screensizeState: ScreensizeStateService) { }

  ngOnInit(): void {
    this.titleId = this.stateService.getSingleElementIdByLabelAndComponent(this.componentId(), 'title');
    this.subtitleId = this.stateService.getSingleElementIdByLabelAndComponent(this.componentId(), 'subtitle');
    this.highlightButtonId = this.stateService.getSingleElementIdByLabelAndComponent(this.componentId(), 'highlight-button');
    this.secondaryButtonId = this.stateService.getSingleElementIdByLabelAndComponent(this.componentId(), 'secondary-button');
    this.heroImageId = this.stateService.getSingleElementIdByLabelAndComponent(this.componentId(), 'hero-image');

  }
}